export default "__VITE_ASSET__CLn0FgjX__"